<div class="faqs-container">
    <div class="faqs-header">
        <p>{{ 'FAQ.TITLE' | translate }}</p>
    </div>
    <div class="faqs-content">
        <div class="search-bar">
            <input pInputText class="faq-input" type="text" (keyup)="filterFaqsElements()" [(ngModel)]="searchValue"
                [placeholder]="'FAQ.SEARCH_PLACEHOLDER' | translate">
            <i class="fa fa-search" aria-hidden="true"></i>
        </div>
        <p-accordion>
            <p-accordionTab *ngFor="let faq of faqs" header="{{ faq.question }}">
                {{ faq.answer }}
            </p-accordionTab>
        </p-accordion>
        <p *ngIf="faqs.length === 0" class="no-result-found">{{ 'FAQ.NO_RESULTS' | translate }}</p>
    </div>
</div>